import React, { useState } from "react";
import { MyProfileGalleryContainer, ImageGallery } from "./MyProfileGalleryStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import camera from './../../utils/images/camera.svg';
import deleteIcon from './../../utils/images/close_circle.svg';
import ImageUploading from 'react-images-uploading';
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { postDeleteFileBase64, postFileBase64 } from "../../api/fileApi";
import { postEditUserDataInfluencer } from "../../api/myAccountApi";
import Spinner from "../Spinner/Spinner";
import { handleImageUpload } from "../../services/compress";
import { getBase64 } from "../../services/generalSevices";
import { useEffect } from "react";

export default function MyProfileGallery() {

    const [imagesToSend, setImagesToSend] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    //const [galleryImage, setGalleryImage] = useState("");

    const { uniqueName, account, userToken, userType, gallery, setGallery } = useContext(UserContext);



    const saveImage = () => {

        setIsLoading(true);

        const imageBody = {
            base64File: imagesToSend[0].data_url.split(',')[1],
            formatFile: imagesToSend[0].file.split('/')[1],
        }
        if (userType === 'influencer') {
            imageBody.address = `fluincr/${account}/profile`
        } else {
            imageBody.address = `company/${account}/profile`
        }

        postFileBase64({ body: imageBody, token: userToken }).then((responseImage) => {

            if (responseImage.length > 0) {

                postEditUserDataInfluencer({ body: { gallery: [...gallery, responseImage] }, token: userToken }).then((response) => {
                    if (response.status === 201) {
                        setGallery([...gallery, responseImage])
                        setIsLoading(false)
                        setImagesToSend([]);
                    }
                })


            }
        })
    }


    useEffect(() => {
        if (imagesToSend.length > 0) {
            saveImage()
        }
    }, [imagesToSend])


    const onChange = (imageList, addUpdateIndex) => {
        setIsLoading(true);
        setImagesToSend(imageList);
        const imageBody = {
            base64File: imageList[0].data_url.split(',')[1],
            formatFile: imageList[0].file.type.split('/')[1],
            //address: `fluincr/${uniqueName}/profile`
            address: `fluincr/${account}/profile`
        }

        postFileBase64({ body: imageBody, token: userToken }).then((responseImage) => {

            if (responseImage.length > 0) {

                postEditUserDataInfluencer({ body: { gallery: [...gallery, responseImage] }, token: userToken }).then((response) => {
                    if (response.status === 201) {
                        setGallery([...gallery, responseImage])
                        setIsLoading(false)
                        setImagesToSend([]);
                    }
                })


            }
        })
    }

    const showCards = () => {
        const array = []

        for (let index = 0; index < (7 - gallery.length); index++) {
            array.push(<>
                {/* <ImageUploading
                value={imagesToSend}
                onChange={onChange}
                //maxNumber={1}
                dataURLKey="data_url"
            >
                {({
                    imageList,
                    onImageUpload,
                    isDragging,
                    dragProps,
                }) => (
                    <div className="upload__image-wrapper">
                        <button type='button'
                            onClick={onImageUpload}
                            {...dragProps}
                            className="imageUploadButton"
                        >
                            <div className="card" >
                                <img src={camera} alt="camera" />
                                <p><FormattedMessage id="my_profile_text_16" defaultMessage="Cargar nueva imagen" /></p>
                            </div>
                        </button>
                    </div>
                )}
            </ImageUploading> */}
                <div className="uploadImage">
                    <label htmlFor="gallery-file-input" className="fileLabel">
                        <div className="card" >
                            <img src={camera} alt="camera" />
                            <p><FormattedMessage id="my_profile_text_16" defaultMessage="Cargar nueva imagen" /></p>
                        </div>
                    </label>

                    <input type="file" id="gallery-file-input" accept="image/png, image/jpeg" /* value={galleryImage}  */ onChange={(e) => {
                        /*setGalleryImage(e.target.value) */
                        setIsLoading(true);
                        handleImageUpload({ event: e, maxWidthOrHeight: 1024 }).then((compressedFile) => {
                            getBase64({ file: compressedFile }).then((image) => {
                                setImagesToSend([{ data_url: image, file: compressedFile.type }]);
                            })
                        })
                    }} />
                </div>
            </>

            )

        }
        return array
    }

    const deleteImage = (image, index) => {
        const newGallery = [...gallery]
        newGallery.splice(index, 1)

        setIsLoading(true)

        const bodyDelete = {
            url: image
        }

        postEditUserDataInfluencer({ body: { gallery: newGallery }, token: userToken }).then((response) => {

            if (response.status === 201) {
                setGallery(newGallery)
                postDeleteFileBase64({ body: bodyDelete, token: userToken }).then((responseDelete) => {
                    setIsLoading(false)
                })

            }
        })
    }


    return (
        <MyProfileGalleryContainer>
            <h2 className="title"><FormattedMessage id="my_profile_subtitle_3" defaultMessage="Contenido" /></h2>
            <div className="cardsContainer">
                {gallery.map((image, index) => {
                    return (
                        <div className="imageContainer">
                            <img src={deleteIcon} alt="delete" className="delete" onClick={() => { deleteImage(image, index) }} />
                            <ImageGallery image={image} />
                        </div>
                    )
                })}
                {showCards()}

                {/* <ImageUploading
                    value={imagesToSend}
                    onChange={onChange}
                    //maxNumber={1}
                    dataURLKey="data_url"
                >
                    {({
                        imageList,
                        onImageUpload,
                        isDragging,
                        dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                            <button type='button'
                                onClick={onImageUpload}
                                {...dragProps}
                                className="imageUploadButton"
                            >
                                <div className="card" >
                                    <img src={camera} alt="camera" />
                                    <p><FormattedMessage id="my_profile_text_16" defaultMessage="Cargar nueva imagen" /></p>
                                </div>
                            </button>
                        </div>
                    )}
                </ImageUploading> */}

                <div className="uploadImage">
                    <label htmlFor="gallery-file-input" className="fileLabel">
                        <div className="card" >
                            <img src={camera} alt="camera" />
                            <p><FormattedMessage id="my_profile_text_16" defaultMessage="Cargar nueva imagen" /></p>
                        </div>
                    </label>

                    <input type="file" id="gallery-file-input" accept="image/png, image/jpeg" /* value={galleryImage} */ onChange={(e) => {
                        //setGalleryImage(e.target.value)
                        setIsLoading(true);
                        handleImageUpload({ event: e, maxWidthOrHeight: 1024 }).then((compressedFile) => {

                            getBase64({ file: compressedFile }).then((image) => {

                                setImagesToSend([{ data_url: image, file: compressedFile.type }]);
                            })
                        })
                    }} />
                </div>

            </div>

            {(isLoading) && (<Spinner />)}

        </MyProfileGalleryContainer>
    )
}